import styled from "styled-components";

export const FieldLabel = styled.div`
    font-size: 12px;
    font-family: 'MulishBold', sans-serif;
    text-transform: uppercase;
`
